var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('dropdown-overlay'),_c('router-view'),(
			_vm.$route.name !== 'checkout' && !_vm.$route.path.includes('customize-pizza')
		)?_c('call-to-action-buttons'):_vm._e(),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }